import { RichTextView } from '@/components/blocks/RichTextView'
import type { ExperienceEntry } from '@/types/content'
import styles from './ExperienceList.module.css'

/** A timeline of roles. Data comes from `src/content/experience.ts`. */
export function ExperienceList({ entries }: { entries: ExperienceEntry[] }) {
  return (
    <ol className={styles.list}>
      {entries.map((entry, i) => (
        <li key={`${entry.organization}-${entry.period}-${i}`} className={styles.item}>
          <div className={styles.logo}>
            <img src={entry.logo.src} alt={entry.logo.alt} loading="lazy" />
          </div>

          <div className={styles.body}>
            <div className={styles.headline}>
              <h3 className={styles.org}>{entry.organization}</h3>
              <span className={styles.period}>{entry.period}</span>
            </div>
            <p className={styles.role}>{entry.role}</p>

            {entry.summary && (
              <p className={styles.summary}>
                <RichTextView value={entry.summary} />
              </p>
            )}

            {entry.highlights && entry.highlights.length > 0 && (
              <ul className={styles.highlights}>
                {entry.highlights.map((highlight, j) => (
                  <li key={j}>
                    <RichTextView value={highlight} />
                  </li>
                ))}
              </ul>
            )}
          </div>
        </li>
      ))}
    </ol>
  )
}
